module.exports = require('./helpers/bundle-url').getBundleURL('ad4mF') + "logo-dark.eefe0b7f.svg";